import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import { userAuth } from './main/-user/user.api';
import { userReducer } from './main/-user/user.slice';
import { partnerCampaigns } from './type-partner/campaigns/campaigns.api';
import { partnerCreatives } from './type-partner/creatives/creatives.api';
import { partnerCreativesDeskApi } from './type-partner/creatives-desk/creativesDesk.api';
import { partnerMentions } from './type-partner/mentions/mentions.api';

import { partnerEventCatalog } from './type-partner/events-catalog/partner-event-catalog.api';
import { partnerEvent } from './type-partner/events/partner-event.api';
import { partnerLandings } from './type-partner/landings/landings.api';
import { organizerEvents } from './type-organizer/events/events.api';
import { organizerLandings } from './type-organizer/landings/landings.api';
import { adOrganizerCredentials } from './type-organizer/credentials/credentials.api';
import { adPartnerCredentials } from './type-partner/credentials/credentials.api';
import { organizerCampaigns } from './type-organizer/campaigns/campaigns.api';
import { organizerBillingApi } from './type-organizer/billing/billing.api';
import { organizerAudiencesApi } from './type-organizer/audiences/audiences.api';
import { organizerPartners } from './type-organizer/partners/partners.api';
import { organizerOnboarding } from './type-organizer/onboarding/organizer-onboarding.api';
import { categories } from './main/categories/categories.api';
import { countriesApi } from './main/countries/countries.api';
import { notificationsApi } from './main/notifications/notifications.api';
import { avatarApi } from './main/avatar/avatar.api';
import { billingApi } from './main/billing/billing.api';
import { moderationReason } from './main/moderation-reasons/moderation-reasons.api';
import { citiesApi } from './main/cities/cities.api';
import { paymentApi } from './main/payment/payment.api';
import { organizationApi } from './main/organization/organization.api';
import { subscriptionApi } from './main/subscription/subscription.api';
import { usersRolesApi } from './main/users-roles/users.api';
import { partnerCampaignsReducer } from './type-partner/campaigns/campaigns.slice';
import { partnerLandingsReducer } from './type-partner/landings/landings.slice';
import { filterEnumsApi } from './main/enums/enums.api';
import { filterEnumsSliceReducer } from './main/enums/enums.slice';
import { email } from './main/email/email.api';
import { aiAssistent } from './type-partner/ai-assistent/ai-assistent.api';
import { aiAssistence } from './ai-assintence/ai-assistence.api';
import { geoLocationApi } from './main/geo/geo.api';
import { automationApi } from './type-partner/automation/automation.api';
import { partnerSnippetsApi } from './type-partner/snippets/snippets.api';
import { partnerBriefsApi } from './type-partner/briefs/briefs.api';
import { partnerMeetingsApi } from './type-partner/meetings/meetings.api';
import { partnerTopicsApi } from './type-partner/topics/topics.api';
import { partnerLeadMagnetsApi } from './type-partner/lead-magnets/lead-magnets.api';
import { partnerLeadQualificationsApi } from './type-partner/lead-qualifications/lead-qualifications.api';
import { billingSliceReducer } from './main/billing/billing.slice';
import { creativesApi } from './type-organizer/creatives/creatives.api';
import { analytics } from './analytics/analytics.api';
import { organizerCreativesModeration } from './type-organizer/organizer-creatives/creatives.api';
import { landingPagesApi } from './landing-pages/landing-pages.api';
import { followReportsApi } from './main/follow-reports/follow-reports.api';
import { mcpTokensApi } from './main/mcp-tokens/mcp-tokens.api';
import { speechApi } from './main/speech/speech.api';
import { aiAgentApi } from './type-partner/ai-agent/ai-agent.api';
import { userSettingsApi } from './main/user-settings/user-settings.api';
import { passkeysApi } from './main/passkeys/passkeys.api';
import { organizationInvitesApi } from './main/organization-invites/organizationInvites.api';
import { adminApi } from './type-admin/admin.base';
import { attendeeEventsApi } from './type-attendee/events/attendee-events.api';
import { attendeeFavoritesApi } from './type-attendee/favorites/attendee-favorites.api';
import { attendeeMatchApi } from './type-attendee/match/match.api';
import { onboardingApi } from './onboarding/onboarding.api';
import { presentationApi } from './presentation/presentation.api';
import { mailingUnsubscribeApi } from './mailing-unsubscribe/mailingUnsubscribe.api';
import { productAnalyticsApi } from './main/product-analytics/productAnalytics.api';
export const store = configureStore({
  reducer: {
    // MAIN
    [notificationsApi.reducerPath]: notificationsApi.reducer,
    [avatarApi.reducerPath]: avatarApi.reducer,
    [categories.reducerPath]: categories.reducer,
    [countriesApi.reducerPath]: countriesApi.reducer,
    [citiesApi.reducerPath]: citiesApi.reducer,
    [geoLocationApi.reducerPath]: geoLocationApi.reducer,
    [billingApi.reducerPath]: billingApi.reducer,
    billingState: billingSliceReducer,
    [moderationReason.reducerPath]: moderationReason.reducer,
    [email.reducerPath]: email.reducer,
    [paymentApi.reducerPath]: paymentApi.reducer,
    [organizationApi.reducerPath]: organizationApi.reducer,
    [subscriptionApi.reducerPath]: subscriptionApi.reducer,
    [usersRolesApi.reducerPath]: usersRolesApi.reducer,
    [filterEnumsApi.reducerPath]: filterEnumsApi.reducer,
    filterEnums: filterEnumsSliceReducer,
    [analytics.reducerPath]: analytics.reducer,
    [userAuth.reducerPath]: userAuth.reducer,
    userAuth: userReducer,
    // PARTNER
    [aiAssistent.reducerPath]: aiAssistent.reducer,
    [partnerCampaigns.reducerPath]: partnerCampaigns.reducer,
    partnerCampaigns: partnerCampaignsReducer,

    [partnerEventCatalog.reducerPath]: partnerEventCatalog.reducer,
    [partnerEvent.reducerPath]: partnerEvent.reducer,
    [partnerLandings.reducerPath]: partnerLandings.reducer,
    partnerLandings: partnerLandingsReducer,
    [adPartnerCredentials.reducerPath]: adPartnerCredentials.reducer,
    [partnerCreatives.reducerPath]: partnerCreatives.reducer,
    [partnerCreativesDeskApi.reducerPath]: partnerCreativesDeskApi.reducer,
    [partnerMentions.reducerPath]: partnerMentions.reducer,
    [automationApi.reducerPath]: automationApi.reducer,
    [partnerSnippetsApi.reducerPath]: partnerSnippetsApi.reducer,
    [partnerBriefsApi.reducerPath]: partnerBriefsApi.reducer,
    [partnerMeetingsApi.reducerPath]: partnerMeetingsApi.reducer,
    [partnerTopicsApi.reducerPath]: partnerTopicsApi.reducer,
    [partnerLeadMagnetsApi.reducerPath]: partnerLeadMagnetsApi.reducer,
    [partnerLeadQualificationsApi.reducerPath]: partnerLeadQualificationsApi.reducer,

    // ORGANIZER aka EVENT
    [organizerPartners.reducerPath]: organizerPartners.reducer,
    [organizerEvents.reducerPath]: organizerEvents.reducer,
    [organizerLandings.reducerPath]: organizerLandings.reducer,
    [organizerCreativesModeration.reducerPath]: organizerCreativesModeration.reducer,
    [adOrganizerCredentials.reducerPath]: adOrganizerCredentials.reducer,
    [organizerCampaigns.reducerPath]: organizerCampaigns.reducer,
    [organizerBillingApi.reducerPath]: organizerBillingApi.reducer,
    [organizerAudiencesApi.reducerPath]: organizerAudiencesApi.reducer,
    [creativesApi.reducerPath]: creativesApi.reducer,
    // AI
    [aiAssistence.reducerPath]: aiAssistence.reducer,

    //COMMON
    [landingPagesApi.reducerPath]: landingPagesApi.reducer,
    [followReportsApi.reducerPath]: followReportsApi.reducer,
    [mcpTokensApi.reducerPath]: mcpTokensApi.reducer,
    [speechApi.reducerPath]: speechApi.reducer,
    [passkeysApi.reducerPath]: passkeysApi.reducer,
    [organizationInvitesApi.reducerPath]: organizationInvitesApi.reducer,
    [aiAgentApi.reducerPath]: aiAgentApi.reducer,
    [userSettingsApi.reducerPath]: userSettingsApi.reducer,
    // ATTENDEE
    [attendeeEventsApi.reducerPath]: attendeeEventsApi.reducer,
    [attendeeFavoritesApi.reducerPath]: attendeeFavoritesApi.reducer,
    [attendeeMatchApi.reducerPath]: attendeeMatchApi.reducer,
    // ADMIN
    [adminApi.reducerPath]: adminApi.reducer,
    // ONBOARDING
    [onboardingApi.reducerPath]: onboardingApi.reducer,
    // PRESENTATION (public start page)
    [presentationApi.reducerPath]: presentationApi.reducer,
    // MAILING UNSUBSCRIBE (public footer link of a mailing)
    [mailingUnsubscribeApi.reducerPath]: mailingUnsubscribeApi.reducer,
    [productAnalyticsApi.reducerPath]: productAnalyticsApi.reducer,
    // not active for moment
    [organizerOnboarding.reducerPath]: organizerOnboarding.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      // MAIN
      .concat(notificationsApi.middleware)
      .concat(avatarApi.middleware)
      .concat(categories.middleware)
      .concat(countriesApi.middleware)
      .concat(citiesApi.middleware)
      .concat(geoLocationApi.middleware)
      .concat(analytics.middleware)
      .concat(billingApi.middleware)
      .concat(moderationReason.middleware)
      .concat(email.middleware)
      .concat(paymentApi.middleware)
      .concat(organizationApi.middleware)

      .concat(subscriptionApi.middleware)
      .concat(usersRolesApi.middleware)
      .concat(filterEnumsApi.middleware)

      // user in needed to refactor
      .concat(userAuth.middleware)
      // COMMON

      // PARTNER
      .concat(aiAssistent.middleware)
      .concat(partnerCampaigns.middleware)
      .concat(partnerEventCatalog.middleware)
      .concat(partnerEvent.middleware)
      .concat(partnerLandings.middleware)
      .concat(adPartnerCredentials.middleware)
      .concat(partnerCreatives.middleware)
      .concat(partnerCreativesDeskApi.middleware)
      .concat(partnerMentions.middleware)
      .concat(automationApi.middleware)
      .concat(partnerSnippetsApi.middleware)
      .concat(partnerBriefsApi.middleware)
      .concat(partnerMeetingsApi.middleware)
      .concat(partnerTopicsApi.middleware)
      .concat(partnerLeadMagnetsApi.middleware)
      .concat(partnerLeadQualificationsApi.middleware)

      // EVENT
      .concat(organizerCampaigns.middleware)
      .concat(organizerBillingApi.middleware)
      .concat(organizerAudiencesApi.middleware)
      .concat(organizerEvents.middleware)
      .concat(organizerLandings.middleware)
      .concat(organizerCreativesModeration.middleware)
      .concat(adOrganizerCredentials.middleware)
      .concat(organizerPartners.middleware)
      .concat(creativesApi.middleware)
      .concat(landingPagesApi.middleware)
      .concat(followReportsApi.middleware)
      .concat(mcpTokensApi.middleware)
      .concat(speechApi.middleware)
      .concat(passkeysApi.middleware)
      .concat(organizationInvitesApi.middleware)
      .concat(aiAgentApi.middleware)
      .concat(userSettingsApi.middleware)
      // AI
      .concat(aiAssistence.middleware)
      // ATTENDEE
      .concat(attendeeEventsApi.middleware)
      .concat(attendeeFavoritesApi.middleware)
      .concat(attendeeMatchApi.middleware)
      // ADMIN
      .concat(adminApi.middleware)

      // ONBOARDING
      .concat(onboardingApi.middleware)
      // PRESENTATION (public start page)
      .concat(presentationApi.middleware)
      .concat(mailingUnsubscribeApi.middleware)
      .concat(productAnalyticsApi.middleware)
      // not active for moment
      .concat(organizerOnboarding.middleware),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
